import { retry } from '../services/sharedUtils';

export default {
  type: 'backend',

  init() {},
  save: {},
  create: {},

  read(language, namespace, callback) {
    retry(() => import(
      /* webpackChunkName: "../locales/[request]" */
      /* webpackExclude: /(__mocks__|backups|country-lists)/ */
      `./${language}.json`
    ))
      .then(data => callback(null, data))
      .catch(callback);
  }
};
